import { IBase, IKitchenArea } from "@app/common";
import { DeepPartial } from "react-hook-form";

export type KitchenAreaFormValues = DeepPartial<IKitchenArea> & {}

export const transformKitchenAreaFormValuesToPayload = (values: Omit<Partial<IKitchenArea>, keyof IBase>): Partial<IKitchenArea> => {
  return {
    ...values,
  }
}

export const transformToUpdatableFormKitchenArea = (kitchenArea?: Partial<IKitchenArea>): KitchenAreaFormValues => {
  return {
    name: kitchenArea?.name,
  }
}
